import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IImageFile } from '../../interfaces';
import { FileModel } from '../../typescript-angular-client/model/fileModel';
import { FolderTreeNode } from '../../typescript-angular-client/model/folderTreeNode';

const MAX_PREVIEW_IMAGE_WIDTH = 178;
const MAX_PREVIEW_IMAGE_HEIGHT = 177;
const SIZE_UNIT = 'px';

@Component({
  selector: 'preview-image',
  templateUrl: './preview.html',
  styleUrls: ['./preview.component.scss']
})

export class PreviewComponent {
  private _imageFile: FileModel;
  private _model: FileModel;
  public previewImageWidth = `0${SIZE_UNIT}`;
  public previewImageHeight = `0${SIZE_UNIT}`;

  get imageFile(): FileModel {
    return this._imageFile;
  }

  @Output() newFileAdded = new EventEmitter<unknown>();
  @Output() editImage = new EventEmitter<FileModel>();
  @Input() previewFileNameMaxLength?: number;
  @Input() previewImgMaxHeight?: number;
  @Input() previewImgMaxWidth?: number;
  @Input() enableImageEditing? = true;
  @Input() set model(fileModel: FileModel) {
    this._model = fileModel;
    if (!fileModel) {
      this._imageFile = null;
      return;
    }
    if (fileModel && fileModel['Id'] !== undefined) {
      this._imageFile = fileModel as FileModel;
    } else {
      const fileModels = Array.isArray(fileModel) ? fileModel : [];
      this._imageFile = fileModels.length > 0 ? fileModels[0] : null;
    }
  }

  get model(): FileModel {
    return this._model;
  }

  get isSeveralFilesSelected(): boolean {
    if (this._model && (this._model as FileModel[]).length !== undefined) {
      return (this._model as FileModel[]).length > 1;
    }
    return false;
  }

  public onEditImage = (): void =>this.editImage.emit(this._imageFile);

  public handlePreviewImageLoad = ($event: Event & HTMLImageElement): void => {
    if (this.previewFileNameMaxLength == null) {
      this.previewFileNameMaxLength = 15;
    }
    if (this.previewImgMaxHeight == null) {
      this.previewImgMaxHeight = MAX_PREVIEW_IMAGE_HEIGHT;
    }
    if (this.previewImgMaxWidth == null) {
      this.previewImgMaxWidth = MAX_PREVIEW_IMAGE_WIDTH;
    }

    const imgElement = $event.target || $event.srcElement;
    const naturalWidth = imgElement['naturalWidth'] as number;
    const naturalHeight = imgElement['naturalHeight'] as number;

    if ((naturalWidth - this.previewImgMaxWidth) > (naturalHeight - this.previewImgMaxHeight)) {
      this.previewImageWidth = `${this.previewImgMaxWidth}${SIZE_UNIT}`;
      this.previewImageHeight = `${Math.round((naturalHeight * (this.previewImgMaxWidth / naturalWidth)))}${SIZE_UNIT}`;
    } else {
      this.previewImageHeight = `${this.previewImgMaxHeight}${SIZE_UNIT}`;
      this.previewImageWidth = `${Math.round((naturalWidth * (this.previewImgMaxHeight / naturalHeight)))}${SIZE_UNIT}`;
    }
  }
}
